import moment from "moment";
import htmlToText from "html-to-text";

export default {
    MakePDF(prog, o_themes) {
        pdfMake.fonts = {
            Times: {
                normal: 'TimesNewRomanCyrRegular.TTF',
                bold: 'TimesNewRomanCyrBold.TTF',
                italics: 'TimesNewRomanCyrItalic.TTF',
                bolditalics: 'TimesNewRomanCyrBoldItalic.TTF'
            }
        }
        moment.locale('ru');
        let n_comp = 0
        let special = ""
        let profile = ""
        let comp_text = " "
        if (prog.main_info.speciality_code === '38.05.02' || prog.main_info.speciality_code === '37.05.01'){
            special = "специальности"
            profile = "Направленность (профиль) программы специалитета"
        }
        else if (prog.main_info.speciality_code === '38.05.01'){
            special = "специальности"
            profile = "Специализация программы специалитета"
        }
        else if (prog.main_info.speciality_code.split('.')[1] === '02'){
            special = "специальности"
            profile = "специализация образовательной программы"
        }
        else if (prog.main_info.speciality_code.split('.')[1] !== '05'){
            special = "направления подготовки"
            profile = "Направленность (профиль) образовательной программы"
        }
        const htmlToText = require('html-to-text');
        function buildComp(){
            var body = [];
            if (prog.main_info.speciality_code.length !== 6 && prog.main_info.speciality_code.length !== 7){
                body.push([{text: `\t  2. Компетенции обучающегося, формируемые в результате освоения дисциплины и индикаторы их достижения`, style: 'twelveBold', alignment: 'justify', colSpan: 4, border: [false, false, false, false]},{},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            return body;
        }
        function buildCompetitionCat() {
            var body = [];
            if (prog.competition.UK.length){
                n_comp += 1
                if (prog.main_info.speciality_code.split('.')[1] === '02') {
                    body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `2.${n_comp}. Общие компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
                    body.push([{text: `Категория (группа) общих компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование общих компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Минимальные требования`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                }
                else {
                    body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `2.${n_comp}. Универсальные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
                    body.push([{text: `Категория (группа) универсальных компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование универсальной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Код и наименование индикатора достижения универсальной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                }
                prog.competition.UK.forEach(function(comp) {
                    body.push([{text: `${comp.info.cat}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${comp.info.code} ${comp.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition.OPK_cat.length){
                n_comp += 1
                if (prog.main_info.speciality_code.split('.')[1] === '02') {
                    body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `2.${n_comp}. Профессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
                    body.push([{text: `Категория (группа) профессиональных компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование профессиональных компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Минимальные требования`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                }
                else {
                    body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: `2.${n_comp} Общепрофессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
                    body.push([{text: `Категория (группа) общепрофессиональных компетенций`, style: 'twelveNormal', colSpan: 2, alignment: 'center', border: [true, true, true, true]},{},{text: `Код и наименование общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]},{text: `Код и наименование индикатора достижения общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'center', border: [true, true, true, true]}])
                }
                prog.competition.OPK_cat.forEach(function(comp) {
                    body.push([{text: `${comp.info.cat}`, style: 'twelveNormal', colSpan: 2,  alignment: 'justify', border: [true, true, true, true]},{},{text: `${comp.info.code} ${comp.info.desc}`, style: 'twelveNormal',  alignment: 'justify', border: [true, true, true, true]},{text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal',  border: [false, false, false, false]},{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }

            return body;
        }
        function buildCompetition() {
            var body = [];
            if (prog.competition.OPK.length){
                n_comp += 1
                if (prog.main_info.speciality_code.split('.')[1] === '02') {
                    body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `2.${n_comp} Профессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                    body.push([{text: `Код и наименование профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                }
                else {
                    body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `2.${n_comp} Общепрофессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                    body.push([{text: `Код и наименование общепрофессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения общепрофессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                }
                prog.competition.OPK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition.PK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `2.${n_comp} Профессиональные компетенции и индикаторы их достижения`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                body.push([{text: `Код и наименование профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                prog.competition.PK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            if (prog.competition.DPK.length){
                n_comp += 1
                body.push([{text: ``, style: 'twelveNormal', alignment: 'justify', border: [false, false, false, false]},{text: `2.${n_comp} Дополнительные профессиональные компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [false, false, false, false]},{}])
                body.push([{text: `Код и наименование дополнительной профессиональной компетенции`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{},{text: `Код и наименование индикатора достижения дополнительной профессиональной компетенции`, style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}])
                prog.competition.DPK.forEach(function(comp) {
                    body.push([{text: `${comp.name}`, style: 'twelveNormal', colSpan: 2, alignment: 'justify', border: [true, true, true, true]},{}, {text: htmlToText.fromString(comp.text, {
                            wordwrap: 10000,
                            tags: {
                                'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } },
                                'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1 } }
                            },
                        }), style: 'twelveNormal', alignment: 'justify', border: [true, true, true, true]}]);
                });
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }
            else{
                body.push([{text: ``, style: 'twelveNormal', colSpan: 3, border: [false, false, false, false]},{},{}])
            }

            return body;
        }
        function buildTheme(themes){
            var info = ''
            themes.forEach(function(theme){
                if (theme.name.replaceAll(" ","").toLowerCase() !== "экзамен" && theme.name.replaceAll(" ","").toLowerCase() !== "зачет" && theme.name.replaceAll(" ","").toLowerCase() !== "зачетсоценкой"){
                    info += theme.name
                    info += '. '
                }
            })

            return info
        }
        let titlePage = {
            info: {
                title: `Аннотация к РП ${prog.main_info.discipline} ${prog.main_info.speciality_code} `,
                author: 'ЦЦТиТО, АмГУ',
                subject: '',
                keywords: ''
            },
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins:[60,40,60,60],

            header:[],
            footer:[],
            content: [
                {
                    text: `Аннотация рабочей программы дисциплины «${prog.main_info.discipline}» для ${special} ${prog.main_info.speciality}.
            ${profile} - ${prog.main_info.profile}\n\n`,
                    style: "twelveBold", alignment: 'center',
                },
                {
                    text: '\t\t 1. Цели и задачи освоения дисциплины', style: "twelveBold", alignment: 'justify',
                },
                {
                    text: `\t\t Цель изучения дисциплины:`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.purpose_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    text: `\t\t Задачи изучения дисциплины:`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: htmlToText.fromString(prog.tasks_old, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,100,130,200],
                        heights: [],
                        body: buildComp()
                    }
                },
                {
                    text: htmlToText.fromString(comp_text, {
                        wordwrap: 10000,
                        whitespaceCharacters: '\t',
                        tags:{
                            'p': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} },
                            'pre': { options: { leadingLineBreaks: 1, trailingLineBreaks: 1} }
                        },
                    }), style: "twelveNormal", alignment: 'justify',
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,100,130,200],
                        heights: [],
                        body: buildCompetitionCat()
                    }
                },
                {
                    style: 'tableExample',
                    table: {

                        widths: [15,150,290],
                        heights: [],
                        body: buildCompetition()
                    }
                },
                {
                    text: `\t\t 3. Содержание дисциплины`, style: "twelveBold", alignment: 'justify',
                },
                {
                    text: `\t\t${buildTheme(o_themes)}`, style: "twelveNormal", alignment: 'justify',
                },
            ],
            styles: {
                eightNormal: {
                    fontSize: 8,
                    font: 'Times',
                    bold: false
                },
                tenNormal: {
                    fontSize: 10.5,
                    font: 'Times',
                    bold: false
                },
                twelveNormal: {
                    fontSize: 12,
                    font: 'Times',
                    bold: false,
                    preserveLeadingSpaces: true
                },
                twelveBold: {
                    fontSize: 12,
                    font: 'Times',
                    bold: true,
                    preserveLeadingSpaces: true
                },
            }
        };
        pdfMake.createPdf(titlePage).download(`Аннотация к РП ${prog.main_info.discipline} ${prog.main_info.speciality_code} ${prog.main_info.year}.pdf`);
    }
}